export const EDIT_USER = 'EDIT_USER';
export const EDIT_PUBLISHER = 'EDIT_PUBLISHER';
export const EDIT_WPARTICLES = 'EDIT_WPARTICLES';
